import { all, apply, put, takeLatest } from 'redux-saga/effects'
import { IActionType, IAxiosResponse } from '../root.types'
import { ReportTypes } from './types'
import reportService from '../../../services/report'
import { loadReportFailure, loadReportSuccess } from './actions'


export function* loadReport(action: IActionType<any>) {
    const {filter} = action.payload

    try {
        const response: IAxiosResponse<any> = yield apply(
            reportService,
            reportService.getAll,
            [filter]
        )

        yield put<any>(loadReportSuccess(response.data))
    } catch (e) {
        yield put<any>(loadReportFailure())
    }

}

export default function* reportSaga() {
    return yield all([
        takeLatest(ReportTypes.LOAD_REPORT_REQUEST, loadReport),
    ])
}